
import { Injectable } from '@angular/core';

import { throwError, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { IFile } from './file.model';
import { IInputFile } from './file.model';
import { IWizardFile } from './file.model';
import { ProgressService } from 'app/core/upload-progress.service';
import { Api } from 'app/core/api.service';
import { ApplicationsService } from 'app/applications/applications.service';

const SRV_ERR_MAP = {
    'bad_file_format ': 'format',
    'FileEmpty': 'empty',
    'FileEncrypted': 'encrypted',
    'FileFormatError': 'corrupted',
    'protected_file': 'encrypted'
};

interface IFileResponse {
    id: string;
    token: string;
    name: string;
    extension: string;
    hash: string;
    size: number;
    mime: string;
    isRecognizable: boolean;
    pagesCount: number;
    account: string;
    email: string;
    created: string;
    validated: string;
    deleted: string;
    isDeleted: boolean;
    isValidated: boolean;
    error: string;
}

@Injectable()
export class FileService {

    constructor(
        private _api: Api,
        private _applicationsService: ApplicationsService,
        private _progressService: ProgressService
        ) {
    }

    /** Возвращает информацию о файле */
    info(file: IWizardFile): Observable<IWizardFile> {
        return this._api
            .get(`/v2/file/${file.id}/${file.token}/info`)
            .pipe(
                map((fileInfo: IFileResponse) => {
                    if (file.progress !== 100) {
                        if (fileInfo.error) {
                            file.error = SRV_ERR_MAP[fileInfo.error] || 'unknown';
                        }
                    }
                    return file;
                })
            );
    }

    /** Удаляет файл */
    remove(file: IWizardFile): Observable<void> {
        if (file.id && file.token) {
            return this._api.delete(`/v2/file/${file.id}/${file.token}`)
                .pipe(
                    map(() => void 0),
                    catchError(() => throwError(void 0))
                );
        } else {
            if (file.abortUpload) {
                file.abortUpload();
            }
            return of(void 0);
        }
    }

    /** Загружает файл на сервер */
    upload(inputFile: IInputFile): Observable<IFile> {
        const formData = new FormData();
        formData.append('0', inputFile.source, inputFile.name);
        return Observable.create(observer => {
            this._progressService.register(progress => {
                observer.next(progress);
            });
            const headers = this._applicationsService.headers();
            this._api
                .post('/v2/file', formData, { headers })
                .pipe(
                    map((response: IFileResponse[]) => {
                        observer.next({
                            id: response[0].id,
                            token: response[0].token
                        });
                        observer.complete();
                    }),
                    catchError(response => {
                        inputFile.error = SRV_ERR_MAP[(response.json() || {})['error']] || 'upload';
                        observer.error(inputFile.error);
                        return throwError(response);
                    }))
                .subscribe();
        });
    }

}